import gql from 'graphql-tag'

import { COUNTRY_FRAGMENT } from "../../graphql";


export const MAP_COUNTRIES_QUERY = gql`
query Countries {
  mapCountries {
    results {
    ...CountryFragment
    }
  }
}
${COUNTRY_FRAGMENT}
`